export const THEME_NAMES = ['light', 'dark'] as const;
